/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './ImageFragment';
import { VideoFragmentDoc } from './VideoFragment';
import { ExternalVideoFragmentDoc } from './ExternalVideoFragment';
import { Model3DFragmentDoc } from './Model3D';
export type MediaFileFragment_ExternalVideo_ = { __typename: 'ExternalVideo', mediaContentType: Types.MediaContentType, id: string, embeddedUrl: string, host: Types.MediaHost };

export type MediaFileFragment_MediaImage_ = { __typename: 'MediaImage', mediaContentType: Types.MediaContentType, image?: { __typename?: 'Image', id?: string | null, url: string, altText?: string | null, width?: number | null, height?: number | null } | null };

export type MediaFileFragment_Model3d_ = { __typename: 'Model3d', mediaContentType: Types.MediaContentType, id: string, alt?: string | null, previewImage?: { __typename?: 'Image', url: string } | null, sources: Array<{ __typename?: 'Model3dSource', url: string }> };

export type MediaFileFragment_Video_ = { __typename: 'Video', mediaContentType: Types.MediaContentType, id: string, alt?: string | null, previewImage?: { __typename?: 'Image', url: string } | null, sources: Array<{ __typename?: 'VideoSource', mimeType: string, url: string, width: number, height: number }> };

export type MediaFileFragment = MediaFileFragment_ExternalVideo_ | MediaFileFragment_MediaImage_ | MediaFileFragment_Model3d_ | MediaFileFragment_Video_;

export declare const MediaFileFragment: import("graphql").DocumentNode;
export const MediaFileFragmentDoc = /*#__PURE__*/ `
    fragment MediaFileFragment on Media {
  ... on MediaImage {
    __typename
    mediaContentType
    image {
      ...ImageFragment
    }
  }
  ... on Video {
    __typename
    mediaContentType
    ...VideoFragment
  }
  ... on ExternalVideo {
    __typename
    mediaContentType
    ...ExternalVideoFragment
  }
  ... on Model3d {
    __typename
    mediaContentType
    ...Model3DFragment
  }
}
    `;